import { createFileRoute, Outlet } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'
import { NAVIGATION_ICONS } from './-components/shared/navigation-config'
import { SettingsShell } from './-components/settings/settings-shell'
import { DevResourcesBreadcrumbs, DevResourcesSidebar } from './-components/dev-resources/dev-resources-nav'
import { DevResourcesPending } from './-components/dev-resources/dev-resources-pending'

/**
 * Layout for the super-admin dev playground, in the account's design (account.tsx): the title bar's trail, the tree
 * of its pages beside them (the phone reaches it from the trail's last crumb), and each page in the reading width.
 * The bare `/dev-resources` redirects to the email templates.
 */
export const Route = createFileRoute('/_app/dev-resources')({
  // The tree lists the email templates under their page, so the list is read on every page here — by a super admin
  // only: the playground is open to any signed-in user, the templates are not (SUPER_ADMIN_ONLY).
  context: () => ({ emailTemplatesQueryOptions: trpc.admin.listEmailTemplates.queryOptions() }),
  loader: ({ context }) => {
    if (context.queryClient.getQueryData(context.sessionUserQueryOptions.queryKey)?.canDevLoginAs)
      context.queryClient.query(context.emailTemplatesQueryOptions).catch(noop)
  },
  component: RouteComponent,
  pendingComponent: DevResourcesPending,
})

function RouteComponent() {
  return (
    <SettingsShell
      icon={NAVIGATION_ICONS.devResources}
      title="Developer resources"
      breadcrumbs={<DevResourcesBreadcrumbs />}
      sidebar={(className) => <DevResourcesSidebar className={className} />}
      contentTestId="dev-resources-content"
    >
      <Outlet />
    </SettingsShell>
  )
}
